export const getTerms = async (resource) => {
    let term;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/term`)
      .then(
        (response) => {
          console.log(response);
          term = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return term;
  }
  